import { Button, Tooltip } from "antd";

const AppNotificationColumns = (goToDetailsPage) => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: true,
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Başlık",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "İçerik",
    dataIndex: "body",
    key: "body",
  },
  {
    title: "Görsel",
    dataIndex: "imageUrl",
    key: "imageUrl",
    width: 350,
    render: (text) => (
      <Tooltip title={text}>
        <div
          style={{
            width: "350px",
          }}>
          <a
            href={text}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              maxWidth: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}>
            {text}
          </a>
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Konu",
    dataIndex: "topic",
    key: "topic",
  },
  {
    title: "Uygulama",
    dataIndex: "app",
    key: "app",
    render: (record) => {
      return record.description + " Uygulaması";
    },
  },
];

export { AppNotificationColumns };
